<template>
  <div class="sms-notification-creator">
    <b-row>
      <b-col md="12">
        <fieldset>
          <legend>Odbiorcy</legend>
          <c-email-recipient-creator :title="`Bezpośredni`" :init-recipients="notification.recipients.direct" @changed="changeRecipients(`direct`, $event)" @input="currentInput = $event"></c-email-recipient-creator>
          <c-email-recipient-creator :title="`CC`" :init-recipients="notification.recipients.cc" @changed="changeRecipients(`cc`, $event)" @input="currentInput = $event"></c-email-recipient-creator>
          <c-email-recipient-creator :title="`BCC`" :init-recipients="notification.recipients.bcc" @changed="changeRecipients(`bcc`, $event)" @input="currentInput = $event"></c-email-recipient-creator>
          <strong>Odpowiedz do (reply-to):</strong>
          <b-input-group>
            <b-form-input ref="replyTo" v-model="notification.replyTo" @select="currentInput = $refs.replyTo" @click="currentInput = $refs.replyTo"/>
          </b-input-group>
        </fieldset>
        <fieldset>
          <legend>Nadawca</legend>
            <strong>Nazwa:</strong>
            <b-input-group>
              <b-form-input ref="sender" v-model="notification.sender" @select="currentInput = $refs.sender" @click="currentInput = $refs.sender"/>
            </b-input-group>
        </fieldset>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col md="12">
        <fieldset>
          <legend>Wiadomość</legend>
          <p>
            <strong>Tytuł:</strong> <b-form-input ref="title" v-model="notification.messageTemplate.title" @select="currentInput = $refs.title" @click="currentInput = $refs.title"/>
          </p>
          <p>
            <strong> Treść:</strong> <i class="fa fa-info-circle" title="Używanie tagów HTML jest dozwolone."></i>
            <b-form-textarea rows="8" v-model="notification.messageTemplate.content" ref="content" @select="currentInput = $refs.content" @click="currentInput = $refs.content"/>
          </p>
        </fieldset>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col md="12">
          <label>Dostępne zmienne:</label>
          <br/>
          <span v-bind:key="i" v-for="(variable, i) in variables">
            <b-badge @click="copyVariable(variable)" variant="success" class="variable rounded-pill cursor-pointer">{{ variable }}</b-badge>&nbsp;
          </span>
        <p>
          <br/>
          <i><b>{overviewUrl}</b> zostanie automatycznie opakowany tagiem &lt;a&gt;</i>
        </p>
      </b-col>
    </b-row>
    <hr>
    <b-button variant="primary" class="float-right" @click="saveNotification()">{{ this.initNotification ? `Zapisz` : `Utwórz` }}</b-button>
  </div>
</template>
<script>

import inputHelper from '../../inputHelper'
import variablesHelper from '../variablesHelper'
import CEmailRecipientCreator from './EmailRecipientCreator'

export default {
  props: ['initNotification', 'variables'],
  components: {
    CEmailRecipientCreator
  },
  data () {
    return {
      notification: this.initializeNotification(),
      currentInput: null,
      newDirectRecipient: null,
      newField: this.empty()
    }
  },
  name: 'c-email-notification-creator',
  methods: {
    initializeNotification () {
      if (this.initNotification) {
        return JSON.parse(JSON.stringify(this.initNotification))
      }
      return this.empty()
    },
    empty () {
      return {
        recipients: {
          direct: [],
          cc: [],
          bcc: []
        },
        messageTemplate: {
          title: null,
          content: this.defaultContent(),
          emptyVariableMessage: null
        },
        replyTo: null,
        sender: 'Octamedia'
      }
    },
    saveNotification () {
      const invalidVariables = variablesHelper.getInvalidVariablesInFields(this.variables, [
        this.notification.messageTemplate.content,
        this.notification.messageTemplate.title,
        this.notification.recipients.direct,
        this.notification.recipients.cc,
        this.notification.recipients.bcc
      ])
      if (invalidVariables.length > 0) {
        this.$notify({ group: 'notify', type: 'error', title: 'Wykryto niedozwolone zmienne', text: invalidVariables.join(', ') })
        return
      }
      this.$emit('saved', this.notification)
    },
    async copyVariable (variable) {
      if (!this.currentInput) return
      inputHelper.copyTextToInput(this.currentInput, variable)
    },
    changeRecipients (type, recipients) {
      this.notification.recipients[type] = recipients
    },
    defaultContent () {
      let variables = ''
      const excluded = ['{formId}', '{overviewUrl}', '{leadId}']
      this.variables.forEach(variable => {
        if (!excluded.includes(variable)) {
          variables += variable.replace(/[{}]/gi, '') + ': ' + variable + '\n'
        }
      })
      return 'Cześć,\n\nOtrzymałeś nowy formularz:\n' + variables + '\nSzczegóły {overviewUrl}'
    }
  }
}
</script>
